import { EnvInterface } from './env-interface';

export const environment: EnvInterface = {
  production: false,
  projectLink: 'https://sandbox-midday.poshvine.com/',
  envName: 'sandbox',
  apiPerksServiceUrl: 'https://sandbox-api.poshvine.com/ps/v1',
  apiPerksServiceUrlV2: 'https://sandbox-api.poshvine.com/ps/v2',
  apiClientsServiceUrl: 'https://sandbox-api.poshvine.com/cs/v1',
  apiUrlPaV1: 'https://sandbox-api.poshvine.com/pa/v1/',
  apiBookingServiceUrl: 'https://sandbox-api.poshvine.com/bs/v1',
  apiBookingServiceUrlV2: 'https://sandbox-api.poshvine.com/bs/v1',
  clientId: '62ef15a7-7f42-4e08-b3cb-8ed2f9141277',
  projectId: '42bc0e6c-4fce-4b44-89d7-3b72c16e0767',
  apiUrlBsV1: 'https://sandbox-api.poshvine.com/bs/v1/',
  apiUrlBsV1Internal: 'https://sandbox-api.poshvine.com/bs/internal',
  apiUrlLsV1: 'https://sandbox-api.poshvine.com/ls/v1/',
  corePath: 'https://sandbox-offerservice.poshvine.com/core_service/v1',
  corePathV2: 'https://sandbox-api.poshvine.com/cs/v1',
  offerPath: 'https://sandbox-offerservice.poshvine.com/offer_service/v1',
  offerPathV2: 'https://sandbox-api.poshvine.com/ps/v1',
  countryId: 'efb468c6-2d84-4caa-a826-ff0ab253d0c6',
  urlsToBeRemoved: [],
  apiLoyaltyServiceUrl: '',
  campaignPath: '',
  apiPointsServiceUrl: 'https://sandbox-api.poshvine.com/pts/v1',
  sentryDsn:
    'https://f105cb8ceb5e92cd930aa258a12d299c@o515678.ingest.us.sentry.io/4507983705276416',
};
